<template>
<div class="form-submission-card">
    <submission-title
        :form_name="name"
        :form_status="form_submission.form_status"
    />

    <submission-subtitle
        :form_status="form_submission.form_status"
        :pdf_mode="pdf_mode"
    />

    <div class="form-submission-card-content">
        <response-text
            v-if="!profile_page"
            class="form-submission-card-content-child"
            question="Description"
            :answer="form_submission.start_right_minute_entry.descriptive_text"
        />
        <list-of-operatives-signatures
            v-if="!profile_page"
            class="form-submission-card-content-child"
            :data="form_submission.start_right_minute_entry.signatures"
            :inline_signature="pdf_mode"
            :show_url="show_url"
            is_nested
        />
    </div>
</div>
</template>

<script>
import ListOfOperativesSignatures from "../forms/ListOfOperativesSignatures";
import ShowSignatureModal from "../modals/ShowSignatureModal";
import SubmissionTitle from "./SubmissionTitle";
import SubmissionSubtitle from "./SubmissionSubtitle";
import ResponseComments from "./responses/ResponseComments.vue";
import ResponseText from "./responses/ResponseText.vue";

export default {
    name: "StartRightMinutesSubmission",
    components: {
        ListOfOperativesSignatures,
        ShowSignatureModal,
        SubmissionTitle,
        SubmissionSubtitle,
        ResponseComments,
        ResponseText,
    },
    props: [
        'name',
        'show_url',
        'form_submission',
        'profile_page',
        'pdf_mode',
    ],
}
</script>
